// Mobile menu and variant selection. Everything else is plain Shopify forms.
(() => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  if (toggle && menu) toggle.addEventListener('click', () => {
    const open = menu.hidden;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
  });

  const form = document.querySelector('[data-product-form]');
  const json = document.querySelector('[data-variants]');
  if (!form || !json) return;
  const variants = JSON.parse(json.textContent);
  const idInput = form.querySelector('[data-variant-id]');
  const addBtn = form.querySelector('[data-add]');
  const priceEl = document.querySelector('[data-price] .price');
  const money = cents => '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });

  form.addEventListener('change', e => {
    if (!e.target.matches('[data-option]')) return;
    const chosen = [...form.querySelectorAll('.opt')].map(f => f.querySelector('input:checked')?.value);
    const v = variants.find(v => v.options.every((o, i) => o === chosen[i]));
    if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
    idInput.value = v.id;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
    if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : '');
    const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
  });
})();
